export default __webpack_public_path__ + "static/media/placeholder_dummy2016-fashion01-de.ad27a3b5.png";